/**
 * header-mega-menu.js
 * Adds keyboard support (Tab/Enter/Escape) and a small hover-intent delay
 * to mega menu and dropdown panels, on top of the CSS :hover behavior.
 */
(function () {
  'use strict';

  var OPEN_DELAY = 80;
  var CLOSE_DELAY = 150;

  function initMenuItem(item) {
    var link = item.querySelector('.header-premium__menu-link');
    var panel = item.querySelector('.mega-menu, .header-premium__dropdown');
    if (!link || !panel) return;

    var openTimer = null;
    var closeTimer = null;

    function open() {
      window.clearTimeout(closeTimer);
      openTimer = window.setTimeout(function () {
        panel.classList.add('is-open-keyboard');
        link.setAttribute('aria-expanded', 'true');
      }, OPEN_DELAY);
    }

    function close() {
      window.clearTimeout(openTimer);
      closeTimer = window.setTimeout(function () {
        panel.classList.remove('is-open-keyboard');
        link.setAttribute('aria-expanded', 'false');
      }, CLOSE_DELAY);
    }

    item.addEventListener('mouseenter', open);
    item.addEventListener('mouseleave', close);

    link.addEventListener('focus', open);
    item.addEventListener('focusout', function (event) {
      if (!item.contains(event.relatedTarget)) close();
    });

    item.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        close();
        link.focus();
      }
    });
  }

  document.querySelectorAll('.header-premium__menu-item.has-dropdown').forEach(initMenuItem);

})();
